
import React from 'react';
import PropTypes from 'prop-types';
import BackgroundWrapper from 'common/designer-modules/modules/background-wrapper';
import JoinButton from 'common/designer-modules/modules/join-button';
import Icon from 'common/components/elements/icons';

const MMSPageHero = ({
   customSiteDesignerData,
   isMobile,
}) => {
   return (
      <BackgroundWrapper
         settings={ customSiteDesignerData }
         isMobile={ isMobile }
         isShowVerivicationCheckbox={ customSiteDesignerData?.show_verified_checkmark }
      >
         {
            (customSiteDesignerData?.show_verified_checkmark || customSiteDesignerData.join_button?.enabled || customSiteDesignerData?.follow_button) && (
               <>
                  {
                     (customSiteDesignerData.join_button?.enabled ||  customSiteDesignerData?.follow_button) && (
                        <div className='flex gap-3'>
                           {
                              customSiteDesignerData.join_button?.enabled && (
                                 <JoinButton
                                    settings={ customSiteDesignerData.join_button }
                                 />
                              )
                           }
                           {
                              customSiteDesignerData?.follow_button && (
                                 <div className='flex items-center justify-center w-11 h-11 rounded-lg border border-divider dark:border-divider bg-panel dark:bg-panel-dark'>
                                    <Icon
                                       name='notifications'
                                       size='2xl'
                                       color='action'
                                    />
                                 </div>
                              )
                           }

                        </div>

                     )
                  }
               </>
            )
         }
      </BackgroundWrapper>
   )

}
MMSPageHero.propTypes = {
   customSiteDesignerData: PropTypes.object,
   isMobile: PropTypes.bool,
};
MMSPageHero.defaultProps = {
   isEditable: false,
}
export default MMSPageHero;


